import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { BlotterComponent } from './blotter/blotter.component';
import { PricePanelComponent } from './price-panel/price-panel.component';
import { LogoComponent } from './header/logo/logo.component';
import { OrderPanelComponent } from './order-panel/order-panel.component';
import { AccountPanelComponent } from './account-panel/account-panel.component';
import { OrderbookComponent } from './order-panel/orderbook/orderbook.component';
import { SwapHistoryComponent } from './account-panel/swap-history/swap-history.component';
import { MyAccountComponent } from './account-panel/my-account/my-account.component';
import { TradeModalComponent } from './trade-modal/trade-modal.component';
import { CancelModalComponent } from './cancel-modal/cancel-modal.component';
import { BaseChartDirective, ThemeService } from 'ng2-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OrderModule } from '../helpers/order.module';
import { GraphComponent } from './price-panel/graph/graph.component';
import { RangeSliderComponent } from './trade-modal/range-slider/range-slider.component';
import { DetailsExpandDirective } from '../directives/details-expand.directive';
import { MultiOrderPipe } from '../helpers/multi.order.pipe';
import { SwapTypeSelectorComponent } from './price-panel/swap-type-selector/swap-type-selector.component';
import {
  CurrencySymbolPipe,
  DateRangeFilter,
  DeletePointIfCpIsJpy,
  FirstCC,
  FormatDateToNYTime,
  PriceFactorPipe,
  SecondCC,
  ShortNumberFormatByCurrencyPairPipe,
  ShortNumberPipe,
  SixLetter
} from '../helpers/pipes';
import { AuthenticationComponent } from '../authentication/authentication.component';
import { BsDatepickerModule, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SuperUserOrderbookComponent } from './order-panel/super-user-orderbook/super-user-orderbook.component';
import { ModifyOrderModalComponent } from './modify-order-modal/modify-order-modal.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { CurrencySelectorComponent } from './price-panel/currency-selector/currency-selector.component';
import { AngularCommonModule, AngularMultiSelectModule } from '@clearing-hub/angular-common';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    BaseChartDirective,
    AngularMultiSelectModule,
    DragDropModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    OrderModule,
    TabsModule.forRoot(),
    AngularCommonModule
  ],
  declarations: [
    AccountPanelComponent,
    BlotterComponent,
    HeaderComponent,
    LogoComponent,
    MyAccountComponent,
    OrderbookComponent,
    OrderPanelComponent,
    PricePanelComponent,
    SwapHistoryComponent,
    TradeModalComponent,
    SixLetter,
    FirstCC,
    SecondCC,
    ShortNumberPipe,
    ShortNumberFormatByCurrencyPairPipe,
    CurrencySymbolPipe,
    CancelModalComponent,
    GraphComponent,
    DateRangeFilter,
    RangeSliderComponent,
    DetailsExpandDirective,
    MultiOrderPipe,
    SwapTypeSelectorComponent,
    PriceFactorPipe,
    DeletePointIfCpIsJpy,
    FormatDateToNYTime,
    SuperUserOrderbookComponent,
    ModifyOrderModalComponent,
    // CardComponent,
    CurrencySelectorComponent
  ],
  exports: [
    BlotterComponent,
    HeaderComponent,
    PricePanelComponent,
    AccountPanelComponent,
    OrderPanelComponent,
    BaseChartDirective,
    LogoComponent,
    TabsModule,
    AngularCommonModule
  ],
  providers: [
    BsModalRef,
    BsDaterangepickerConfig,
    PriceFactorPipe,
    DeletePointIfCpIsJpy,
    FirstCC,
    SecondCC,
    ThemeService
  ]
})
export class ComponentsModule {
}

